import styled from 'styled-components';
import { Button, Field } from '@fluentui/react-components';
import { TeamWidgetSearchBox } from 'src/components/Timeoff/widgets/TeamWidget/styles/TeamWidgetAutocomplete.styled';
import { Popup } from '@fluentui/react';

export const FeedbackTabContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  background: ${({ theme }) => theme.feedbackBackground};
  grid-gap: 20px;
  overflow: hidden;
  @media (max-width: 768px) {
    grid-template-columns: 100%;
    grid-gap: 0px;
    height: 100vh;
    overflow-y: none;
  }
`;

export const FeedbackContainer = styled.div`
  width: 100%;
  height: 100vh;
  background: ${({ theme }) => theme.feedbackContainersBackground};
  box-shadow:
    0 0 2px 0 rgba(0, 0, 0, 0.12),
    0 1px 2px 0 rgba(0, 0, 0, 0.14);
  border-radius: 4px;
`;

export const FeedbackBackdrop = styled(Popup)`
  background: ${(props) => props.theme.popupOpacity};
  bottom: 0;
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
  z-index: 2;
`;

export const FeedbackWidgetContainer = styled.div`
  background: ${(props) => props.theme.skillsAccordionBackground};
  bottom: 0;
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
  z-index: 2;
  width: 420px;
  height: fit-content;
  margin: auto;
  overflow-x: hidden;
  border-radius: 2px;
  max-height: 100svh;

  box-shadow:
    0 0 2px 0 rgba(0, 0, 0, 0.12),
    0 1px 2px 0 rgba(0, 0, 0, 0.14);

  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const FeedbackHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 60px;
  border-bottom: 1px solid ${({ theme }) => theme.feedbackDividersColor};
  padding: 0 32px;
  font-size: 18px;
  font-weight: 700;
  svg,
  p {
    cursor: pointer;
  }
  p {
    color: #5b5fc7;
    font-weight: 600;
    font-size: 14px;
  }
`;

export const FeedbackTabViewTitle = styled.h1`
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
`;

export const FeedbackTable = styled.div<{ isBottomContainerVisible: boolean }>`
  display: flex;
  flex-direction: column;
  height: ${({ isBottomContainerVisible }) =>
    isBottomContainerVisible ? 'calc(100vh - 132px)' : 'calc(100vh - 66px)'};
  padding: 0 24px;
  overflow-y: auto;
  @media (max-width: 768px) {
    padding: 0;
  }
`;

export const TableHeader = styled.h1`
  font-size: 14px;
  font-weight: 600;
`;

export const FeedbackText = styled.p`
  font-size: 14px;
  font-weight: 400;
  @media (max-width: 768px) {
    font-size: 16px;
    font-weight: 400;
  }
  p:nth-child(2) {
    font-size: 14px;
    color: #616161;
  }
`;

export const RequestedFeedbackContainer = styled.div<{
  isHeader?: boolean;
  isSelected?: boolean;
}>`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 120px;

  height: 48px;
  padding-left: 12px;
  align-items: center;
  background: ${({ isSelected, theme }) =>
    isSelected ? theme.feedbackAccordionSelected : 'transparent'};
  border-bottom: ${({ isHeader, theme }) =>
    isHeader
      ? '2px solid #5B5FC7'
      : `1px solid ${theme.feedbackDividersColor}`};
  @media (max-width: 768px) {
    grid-template-columns: 65% 25% 10%;
    justify-content: space-between;
    padding: 12px 16px 12px 16px;
    height: 70px;
  }
`;

export const OpenFeedbackButton = styled(Button)`
  margin: auto;
`;

export const FeedbackForm = styled.form`
  display: flex;
  overflow-y: auto;
  flex-direction: column;
  max-height: calc(100vh - 132px);
  padding: 0 32px;
  padding-top: 20px;
  gap: 16px;
  padding-bottom: 30px;
  overflow-x: hidden;
  @media (max-width: 768px) {
    padding: 0 20px;
    padding-top: 16px;
    padding-bottom: 16px;
    height: 100vh;
  }
`;

export const FeedbackField = styled(Field)`
  display: flex;
  flex-direction: column;
  gap: 8px;
  position: relative;
  label {
    font-size: 14px;
    font-weight: 600;
  }
  input {
    @media (max-width: 768px) {
      font-size: 16px;
    }
  }
  textarea {
    @media (max-width: 768px) {
      font-size: 16px;
    }
  }
`;

export const EmployeeSuggestionsFeedback = styled.div`
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  position: absolute;
  background: ${({ theme }) => theme.feedbackContainersBackground};
  border-radius: 4px;
  gap: 2px;
  box-shadow:
    0 0 2px 0 rgba(0, 0, 0, 0.12),
    0 1px 2px 0 rgba(0, 0, 0, 0.14);
  z-index: 5;
  top: 60px;
  width: 100%;
  height: 100px;
  padding: 4px;
  p {
    cursor: pointer;
    padding: 6px;
    border-radius: 4px;
    &:hover {
      background: ${({ theme }) => theme.feedbackEmployeeSuggestionHover};
    }
  }
`;

export const FooterButtons = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 32px;
  height: 72px;
  gap: 12px;
  border-top: 1px solid ${({ theme }) => theme.feedbackDividersColor};
  p {
    color: #5b5fc7;
    cursor: pointer;
  }

  @media (max-width: 768px) {
    padding: 0 12px;
  }
`;

export const ButtonActions = styled.div`
  display: flex;
  flex-direction: row;
  gap: 12px;
`;

export const CompanyValuesContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 12px;
`;

export const CompanyValueButton = styled(Button)<{
  selected: boolean;
}>`
  border-color: ${({ theme }) => theme.feedbackCompanyValuesButtonBorderColor};
  max-width: unset;
  min-width: unset;
  width: auto;
  &:hover {
    background: ${({ selected, theme }) =>
      selected ? theme.feedbackAccordionSelected : 'transparent'};
    border-color: #5b5fc7;
  }
  background: ${({ selected, theme }) =>
    selected ? theme.feedbackAccordionSelected : 'transparent'};
`;

export const LabelIconContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const EmployeeSearchBox = styled(TeamWidgetSearchBox)`
  position: static;
  background: #f5f5f5;
  outline: none;
  border: none;
  width: 100%;
`;

export const MobileOpenFormButton = styled.div`
  position: fixed;
  background: #5b5fc7;
  border-radius: 100px;
  padding: 8px;
  bottom: 20px;
  right: 20px;
  width: 135px;
  height: 48px;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  font-weight: 600;
  gap: 2px;
  cursor: pointer;
  &:active {
    background: #3f4299;
  }
`;

export const FeedbackEmptyStateContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  img {
    width: 426px;
    height: 200px;
    @media (max-width: 768px) {
      max-width: 320px;
      max-height: 140px;
    }
  }
  button {
    margin-top: 15px;
    width: 65%;
  }

  @media (max-width: 768px) {
    padding: 0 12px;
  }
`;

export const FeedbackEmptyStateTitle = styled.h1`
  font-size: 18px;
  font-weight: 600;
  margin-top: 20px;
  margin-bottom: 10px;
  @media (max-width: 768px) {
    text-align: center;
  }
`;

export const FeedbackEmptyStateText = styled.p`
  font-size: 14px;
  font-weight: 400;
  text-align: center;
  margin-bottom: 16px;
`;

export const EmptyStateButton = styled(Button)`
  max-width: 430px;
`;
